import React from "react";
import { WhaleAgentData } from "../../Components/interface";
import { ScoreRadarChart } from "../ScoreRadarChart";
import { FlowBarComponent } from "../FlowBar";

export const WhaleAgentComponent = ({
  data,
}: {
  data: WhaleAgentData | null;
}) => {
  if (!data) return <div>Loading layout...</div>;

  const chartData = [
    {
      subject: "Holder Concentration",
      value: data.wallet_behavior.holder_concentration_score ?? 0,
    },
    {
      subject: "Whale Activity",
      value: data.wallet_behavior.whale_activity_score ?? 0,
    },
    {
      subject: "Smart Money",
      value: data.wallet_behavior.smart_money_conviction_score ?? 0,
    },
    {
      subject: "Coordination Risk",
      value: data.wallet_behavior.coordination_risk_score ?? 0,
    },
  ];

  return (
    <div className="whale-report">
      <div className="whale-report-header">
        <div className="whale-report-title">WHALE AGENT REPORT</div>

        <div className="whale-report-pills">
          <div className="whale-pill whale-pill-accumulating">
            {data.whale_state.toUpperCase()}
          </div>

          <div className="whale-pill whale-pill-score">
            {data.overall_whale_score} WHALE SCORE
          </div>

          <div className="whale-pill whale-pill-confidence">
            {data.confidence_scor} CONFIDENCE
          </div>
        </div>
      </div>

      {/* SUMMARY */}

      <div className="whale-summary-section">
        <div className="whale-section-title">Whale Summary</div>

        <div className="whale-summary">{data.whale_summary}</div>
      </div>

      {/* RADAR */}

      <div className="whale-radar-section">
        <div className="whale-section-title">Whale Behavior Profile</div>

        <div className="whale-radar-container">
          {/* Radar Chart Here */}
          <ScoreRadarChart scores={chartData} type="whale" />
        </div>
      </div>

      {/* WALLET BEHAVIOR */}

      <div className="whale-grid-section">
        <div className="whale-section-title">Wallet Behavior</div>

        <div className="whale-grid">
          <div className="whale-card">
            <div className="whale-card-value">
              {data.wallet_behavior.holder_concentration_score}
            </div>

            <div className="whale-card-label">Holder Concentration</div>
          </div>

          <div className="whale-card">
            <div className="whale-card-value">
              {data.wallet_behavior.whale_activity_score}
            </div>

            <div className="whale-card-label">Whale Activity</div>
          </div>

          <div className="whale-card">
            <div className="whale-card-value">
              {data.wallet_behavior.smart_money_conviction_score}
            </div>

            <div className="whale-card-label">Smart Money Conviction</div>
          </div>

          <div className="whale-card">
            <div className="whale-card-value">
              {data.wallet_behavior.coordination_risk_score}
            </div>

            <div className="whale-card-label">Coordination Risk</div>
          </div>
        </div>
      </div>

      {/* CAPITAL FLOW */}

      <div className="whale-grid-section">
        <div className="whale-section-title">Capital Flow</div>
        <div className="whale-capital-grid">
          <div className="whale-card flex flex-wrap">
            <FlowBarComponent
              percentage={data.capital_flow.inflow_score}
              label="Inflow"
              type="inflow"
            />
            <FlowBarComponent
              percentage={data.capital_flow.outflow_score}
              label="Outflow"
              type="outflow"
            />
          </div>

          <div className="whale-card flex flex-wrap">
            <FlowBarComponent
              percentage={data.capital_flow.buy_pressure_score}
              label="Buy pressure"
              type="buy"
            />
            <FlowBarComponent
              percentage={data.capital_flow.sell_pressure_score}
              label="Sell Pressure"
              type="sell"
            />
          </div>
        </div>
      </div>

      {/* SIGNALS */}

      <div className="whale-block-section">
        <div className="whale-section-title">Whale Signals</div>

        <div className="whale-signals-list">
          {data.whale_signals.map((signal, index) => (
            <div key={index} className="whale-signal">
              {signal}
            </div>
          ))}
        </div>
      </div>

      {/* SUSPICIOUS */}

      {/* <div className="whale-block-section">
        <div className="whale-section-title">Suspicious Patterns</div>

        <div className="whale-patterns-list">
          {data.suspicious_patterns.map((signal, index) => (
            <div key={index} className="whale-pattern">
              {signal}
            </div>
          ))}
        </div>
      </div> */}

      <div className="whale-dominant-section">
        <div className="whale-section-title">Dominant Behavior</div>

        <div className="whale-dominant">{data.dominant_behavior}</div>
      </div>

      {/* MARKET IMPACT */}

      <div className="whale-impact-section">
        <div className="whale-section-title">Market Impact</div>

        <div className="whale-impact">{data.market_impact}</div>
      </div>
    </div>
  );
};
